import create from "zustand";

const useDataStore = create((set) => ({
  redirectData: "",
  addRedirectData: (data) => set((state) => ({ redirectData: data })),
  removeRedirectData: () => set((state) => ({ redirectData: "" })),
}));

export default useDataStore;
